import { Message } from '../../../services/chatService';

/* eslint-disable complexity, max-lines-per-function */
/**
 * Extrai dados de mensagem de diferentes formatos de payload
 */
export const extractMessageData = (
  data: unknown
): {
  id: string;
  content: string;
  direction: 'INCOMING' | 'OUTGOING';
  sender: 'CLIENT' | 'ADMIN' | 'BOT';
  timestamp: string;
  conversationId?: string;
} | null => {
  if (!data || typeof data !== 'object') return null;

  const dataObj = data as Record<string, unknown>;
  const messageData = ('message' in dataObj ? dataObj.message : dataObj) as Record<string, unknown>;

  const rawSender = (messageData.sender ||
    dataObj.sender ||
    messageData.from ||
    dataObj.from ||
    'CLIENT') as string;
  const sender: 'CLIENT' | 'ADMIN' | 'BOT' =
    rawSender === 'CLIENT' || rawSender === 'ADMIN' || rawSender === 'BOT'
      ? (rawSender as 'CLIENT' | 'ADMIN' | 'BOT')
      : 'CLIENT';

  let direction: 'INCOMING' | 'OUTGOING' =
    ((messageData.direction || dataObj.direction) as 'INCOMING' | 'OUTGOING') || 'INCOMING';

  if (!messageData.direction && !dataObj.direction) {
    direction = sender === 'CLIENT' ? 'INCOMING' : 'OUTGOING';
  }

  const content = (messageData.content ||
    dataObj.content ||
    messageData.message ||
    dataObj.message ||
    (messageData.text && typeof messageData.text === 'object' && 'body' in messageData.text
      ? (messageData.text as Record<string, unknown>).body
      : undefined) ||
    '') as string;

  return {
    id: (messageData.id ||
      dataObj.id ||
      messageData.messageId ||
      dataObj.messageId ||
      `msg-${Date.now()}`) as string,
    content,
    direction,
    sender,
    timestamp: (messageData.createdAt ||
      messageData.timestamp ||
      dataObj.createdAt ||
      dataObj.timestamp ||
      new Date().toISOString()) as string,
    conversationId: ('conversationId' in dataObj ? dataObj.conversationId : undefined) as
      | string
      | undefined,
  };
};

/**
 * Cria uma nova mensagem a partir dos dados extraídos
 */
export const createMessage = (data: ReturnType<typeof extractMessageData>): Message | null => {
  if (!data) return null;

  return {
    id: data.id,
    content: data.content,
    direction: data.direction,
    sender: data.sender,
    timestamp: data.timestamp,
    createdAt: data.timestamp,
    isRead: data.sender !== 'CLIENT',
  };
};

/**
 * Verifica se uma mensagem já existe em uma lista
 */
export const messageExists = (messages: Message[], messageId: string): boolean => {
  return messages.some((msg) => msg.id === messageId);
};

/**
 * Cria uma mensagem temporária para envio
 */
export const createTemporaryMessage = (content: string): Message => {
  return {
    id: `temp-${Date.now()}`,
    content,
    direction: 'OUTGOING',
    sender: 'ADMIN',
    timestamp: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    isRead: true,
  };
};

/**
 * Extrai valor de contagem de diferentes formatos
 */
export const extractWaitingCount = (data: unknown): number | null => {
  if (typeof data === 'number') return data;

  if (data && typeof data === 'object' && 'count' in data) {
    const count = (data as Record<string, unknown>).count;
    if (typeof count === 'number') return count;
  }

  return null;
};
